import { render, staticRenderFns } from "./AbkStudentList.vue?vue&type=template&id=8ffb08ac&scoped=true&"
import script from "./AbkStudentList.vue?vue&type=script&lang=js&"
export * from "./AbkStudentList.vue?vue&type=script&lang=js&"
import style0 from "./AbkStudentList.vue?vue&type=style&index=0&id=8ffb08ac&scoped=true&lang=scss&"
import style1 from "./AbkStudentList.vue?vue&type=style&index=1&id=8ffb08ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffb08ac",
  null
  
)

export default component.exports